import React from 'react'

import {noop} from 'es-toolkit'

import './checkbox-field.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import checkedIcon from '../../assets/icons/checked.svg'
import minusIcon from '../../assets/icons/minus.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    checked?: boolean
    partial?: boolean
    appearance?: 'base' | 'error'
    disabled?: boolean
    id?: string
    name?: string
    onChange?: (
      value: boolean,
      name: string | undefined,
      event: React.ChangeEvent<HTMLInputElement>
    ) => void
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  }
>

const CheckboxField = ({
  className,
  checked = false,
  partial = false,
  appearance = 'base',
  disabled = false,
  id,
  onChange = noop,
  onBlur,
  name,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn(
      'CheckboxField',
      {checked: !!checked, [`appearance-${appearance}`]: !!appearance, disabled},
      className
    )}
    aria-checked={checked}
    aria-disabled={disabled}
    role="checkbox"
  >
    <input
      name={name}
      id={id}
      className="CheckboxField__input"
      type="checkbox"
      disabled={disabled}
      onChange={event => {
        if (!disabled) {
          onChange(!checked, name, event)
        }
      }}
      onBlur={onBlur}
    />
    {(checked || partial) && (
      <div className="CheckboxField__checkedIcon">
        <Icon source={partial ? minusIcon : checkedIcon} />
      </div>
    )}
  </div>
)

export default CheckboxField
